<template>
  <div class="mapping">
    <div class="content">

      <div class="newtable-title">
        <div class="left-t">
          <span>产量管理</span>
        </div>
        <div class="btns">
          <el-button type="primary" @click="add_ed(0)">手工新增日产量</el-button>
        </div>

      </div>
      <div class="unify-search-input-btn">
        <div class="input-small">
          <span class="search-name">模型：</span>
          <el-cascader v-model="workshop" :options="options" @change='changeSelect'
            :props="{ checkStrictly: true,label:'modelName',value:'id' }" :show-all-levels="false"></el-cascader>
          <span class="search-name ml-2">开始时间：</span>
          <el-date-picker v-model="startDate" type="date" placeholder="选择开始时间" :picker-options="pickerOptions">
          </el-date-picker>
          <span class="search-name ml-2">结束时间：</span>
          <el-date-picker v-model="endDate" type="date" placeholder="选择结束时间" :picker-options="pickerOptions">
          </el-date-picker>
          <!-- <el-button type="primary" @click="getList" class="search-btn">查询</el-button> -->
          <el-button type="primary" @click="getList" plain class="search-btn">查询</el-button>
        </div>
      </div>

      <div class="mapping-table">
        <el-table :data="tableData" v-loading="loading" stripe style="width: 100%" :max-height="heights">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" width="205"> </el-table-column>
          <el-table-column label="日期" width="204">
            <template slot-scope="scope"><span>{{ scope.row.startTime | parseTime('{y}-{m}-{d}')}}</span></template>
          </el-table-column>
          <el-table-column label="开始时间" width="204">
            <template slot-scope="scope"><span>{{ scope.row.startTime | parseTime('{h}:{i}:{s}')}}</span></template>
          </el-table-column>

          <el-table-column label="结束时间" width="204">
            <template slot-scope="scope"><span>{{ scope.row.endTime | parseTime('{h}:{i}:{s}')}}</span></template>
          </el-table-column>
          <el-table-column prop="capacityValue" label="产能值" />
          <el-table-column prop="predictCapacity" label="计划产量" />
          <el-table-column label="填报类型" width="120">
            <template slot-scope="scope"><span>{{ scope.row.sourcesType =='REMOTE' ? '自动填报' : '手工填报'}}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">
                <el-button type="text" @click="edit_ed(row,0)" style="color:#409eff;font-weight: bold">编辑</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->
    <el-dialog width="30%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div class="dialogs">
        <el-form :model="temp" ref="temp" :rules="rules" style="width:100%;height: 280px;padding-top: 10px;">

          <el-form-item label="产品名称:" prop="productName">
            <el-input v-model="temp.productName" :disabled="dialogStatus==='edit'"></el-input>
          </el-form-item>

          <el-form-item label="产能值:" prop="capacityValue">
            <el-input v-model="temp.capacityValue"></el-input>
          </el-form-item>
          <el-form-item label="计划产量:" prop="predictCapacity">
            <el-input v-model="temp.predictCapacity"></el-input>
          </el-form-item>
          <el-form-item label="开始时间:" prop="startTime">
            <el-date-picker v-model="temp.startTime" type="datetime" placeholder="选择开始时间" value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" prop="endTime">
            <el-date-picker v-model="temp.endTime" type="datetime" placeholder="选择结束时间" value-format="timestamp">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="日期:" prop="date">
            <el-time-picker is-range v-model="temp.date" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间" placeholder="选择时间范围" @change="adds" value-format="timestamp">
            </el-time-picker>
          </el-form-item> -->
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {getMappingList,recordFindList,recordUpdateValue,recordSave,recordUpdateInfo} from "../../api/capacity";
  import elRadioTree from '@/components/module/tree/elRadioTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elRadioTree,
      downloadTable
    },
    data () {
      var validatePass=(rule,value,callback) => {
        if((this.temp.startTime+86400000)<this.temp.endTime||this.temp.startTime>this.temp.endTime) {
          callback(new Error('结束时间在开始时间24小时内！'));
        } else {
          callback();
        }
      };
      return {

        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        loading: false,
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增填报",
          edit: "编辑填报"
        },
        temp: {
          'capacityName': "",
          'localDevice': "",
          'localDeviceNo': ""
        },
        rules: {
          productName: [
            {required: true,message: '请输入产品名称',trigger: 'blur'}
          ],
          date: [
            {required: true,message: '请选择时间',trigger: 'change'}
          ],
          startTime: [
            {required: true,message: '请选择开始时间',trigger: 'change'}
          ],
          endTime: [
            {required: true,message: '请选择结束时间',trigger: 'change'},
            {validator: validatePass,trigger: 'change'}
          ],
          predictCapacity: [
            {required: true,message: '请输入预计日生产量',trigger: 'blur'}
          ],

          capacityValue: [
            {required: true,message: '请输入产量',trigger: 'blur'}
          ]
        },
        tableData: [],
        startDate: '',
        endDate: new Date(),
        options: [],
        workshop: '',
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        editType: 0
      };
    },

    mounted () {
      var date=new Date();
      date.setDate(1);
      var cTime=new Date(new Date(date).toLocaleDateString()).getTime();
      this.startDate=cTime
      this.getSelectList()

    },
    computed: {
      unitId () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      unitId () {
        this.getSelectList()
      },
    },

    methods: {
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      //获取下拉框列表
      getSelectList () {
        var params={'unitId': this.unitId.id}
        this.tableData=[];
        request({url: "/dissipation/model/findModelTree",method: "get",params}).then(res => {
          console.log(res,'111');
          if(res.code==200) {
            this.options=res.data.children;
            console.log(this.options,'11');
            if(this.options.length) {
              this.workshop=[this.options[0].id]
              this.getList()
            }

          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')
          }
        })
      },
      //获取数据
      getList () {
        this.loading=true;
        var params={
          capacityId: this.workshop[this.workshop.length-1],
          startDate: typeof this.startDate=='number'? this.startDate:this.startDate.getTime(),
          endDate: typeof this.endDate=='number'? this.endDate:this.endDate.getTime(),
        }

        var d=
          console.log(d,'dd');
        request({url: "/dissipation/record/findList",method: "get",params}).then(res => {
          console.log(res,'res');
          if(res.code==200) {
            this.tableData=res.data
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查配置！！')
          }
          this.loading=false
        })

      },
      adds (v) {
        console.log(v,11);
      },
      //下拉框
      changeSelect (val) {
        this.getList()
      },

      // 添加弹窗
      add_ed (v,l) {
        this.editType=1
        this.temp={}
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 确认添加
      add_fn (formName) {
        console.log(this.temp.date);
        this.$refs[formName].validate(valid => {
          if(valid) {
            var data={
              "capacityId": this.workshop[this.workshop.length-1],
              "capacityValue": this.temp.capacityValue,
              "predictCapacity": this.temp.predictCapacity,
              "productName": this.temp.productName,
              "sourcesType": 'MANUAL',
              "startTime": this.temp.startTime,
              "endTime": this.temp.endTime,
            }
            request({url: "/dissipation/record/save",method: "POST",data}).then(res => {
              if(res.code==200) {
                this.$message({showClose: true,message: '添加成功',type: 'success'});
                this.getList()
                this.dialogVisible=false;
              } else {
                res.message? this.$message.error(res.message):this.$message.error('查询失败，请检查配置！！')
              }
              this.loading=false
            })
          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            var data=this.temp
            data.uid=data.id;
            delete data.id;


            request({url: "/dissipation/record/save",method: "POST",data}).then(res => {
              if(res.code==200) {
                this.getList()
                this.dialogVisible=false;
                this.$message({showClose: true,message: '编辑成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error('编辑失败')
              }
              this.loading=false
            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗 0 为自动填报，1为手工填报
      edit_ed (v,type) {
        this.textMap.edit='编辑手工填报'
        this.editType=type;
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        // this.$set(this.temp,'date',[v.startTime,v.endTime])
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });




      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();

        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-产量管理','.mapping-table')
      },



    },
    filters: {
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';
        let strDate=Y+M+D;
        return strDate
      },
    }
  };
</script>

<style lang="scss" scoped>
  .mapping {
    width: 100%;
    height: 100%;
    background-color: #ebf4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      padding: 20px;
      box-sizing: border-box;
      background-color: #fff;

      .mapping-table {
        margin-top: 20px;

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 20px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

    }

    .dialogs {
      /deep/.el-input__inner {
        width: 250px;
      }
    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;

      span {
        color: #67A3ED;
        font-size: 16px;
      }

      .el-icon-close {
        font-size: 22px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #f5f5f5;

      button {
        padding: 8px 17px;
      }
    }

    /deep/.el_Tree_Body {
      height: 99.5%;
    }

    .demo-temp {
      display: flex;
      flex-wrap: wrap;
    }

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 85px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }


  }
</style>